import { LINK_KEY } from '@techchange/pm-specs';
import { Plugin, PluginKey } from 'prosemirror-state';

import LinkView from '../nodeView';

export const linkViewPluginKey = new PluginKey('linkViewPlugin');

/**
 * Plugin that manages the link view.
 *
 * @param {string} scope    The scope of the link.
 * @param {string} scopeId  The scope ID of the link.
 *
 * @returns {Object} Prosemirror Plugin object.
 */
const linkViewPlugin = (scope, scopeId) =>

	new Plugin({

		key: linkViewPluginKey,

		props: {

			nodeViews: {

				[LINK_KEY]: (node, view) => new LinkView(node, view, scope, scopeId),

			},

		},

	});

export default linkViewPlugin;
